

import aimarketing from './detail/ai-marketing/data';
import aieditlab from './detail/aieditlab/data';
import caribbeanrealestatemls from './detail/caribbeanrealestatemls/data';
import casino from './detail/casino/data';
import investorsplaybook from './detail/investors-playbook/data';
import koreancar from './detail/koreancar/data';
import langwithai from './detail/langwithai/data';
import metaeditor from './detail/metaeditor/data';
import mindorio from './detail/mindorio/data';
import playbookmedia from './detail/playbook-media/data';
import pydantic2 from './detail/pydantic2/data';
import telesite from './detail/telesite/data';
import ueaudi from './detail/ue-audi/data';
import uetoronto from './detail/ue-toronto/data';
import wixi from './detail/wixi/data';

import type { ProjectData } from './types';

const data: ProjectData[] = [
    pydantic2,
    aimarketing,
    mindorio,
    aieditlab,
    koreancar,
    caribbeanrealestatemls,
    casino,
    investorsplaybook,
    langwithai,
    metaeditor,
    playbookmedia,
    telesite,
    ueaudi,
    uetoronto,
    wixi,
]

export const getProjectData = (slug: string): ProjectData => {
    for (const projectData of data) {
        if (projectData.slug === slug) {
            const filePath = `src/views/projects/detail/${slug}/${projectData.fileName}`;
            return {
                ...projectData,
                filePath,
            };
        }
    }

    return {
        slug: 'unknown',
        title: 'Unknown',
        description: 'Unknown project',
        fileName: '',
    };
}

export default data;